import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    popoverId: String
  }

  open() {
    const popover = document.getElementById(this.popoverIdValue)
    if (!popover?.showPopover) return
    popover.showPopover()
  }
}
